import settingsSlice from './settings';

export default {
  settingsSlice,
};
